import Vue from 'vue'

import { MutationTree } from 'vuex'

import { Order, OrderFilters } from '@/models'

import { makeRelationalObject } from '../../models'
import { InvoiceOrders, OrderingState } from '../state'

export const ADD_INVOICE_ORDERS = 'ADD_INVOICE_ORDERS'
export const ADD_ORDER = 'ADD_ORDER'
export const APPLY_ORDER_FILTERS = 'APPLY_ORDER_FILTERS'
export const CLEAR_INVOICES_ORDERS = 'CLEAR_INVOICES_ORDERS'
export const INCREMENT_ORDERS_QUERY_INDEX = 'INCREMENT_ORDERS_QUERY_INDEX'
export const LOADED_ALL_INVOICE_ORDERS = 'LOADED_ALL_INVOICE_ORDERS'
export const LOADED_ALL_ORDERS = 'LOADED_ALL_ORDERS'
export const RESET_LOADED_ALL_ORDERS = 'RESET_LOADED_ALL_ORDERS'
export const RESET_LOADED_ALL_INVOICE_ORDERS = 'RESET_LOADED_ALL_INVOICE_ORDERS'
export const RESET_ORDERS_QUERY_INDEX = 'RESET_ORDERS_QUERY_INDEX'
export const SET_ORDERS_DEFAULT_FILTERS_FLAG = 'SET_ORDERS_DEFAULT_FILTERS_FLAG'
export const UPDATE_ORDERS = 'UPDATE_ORDERS'
export const UPDATE_INVOICE_ORDERS = 'UPDATE_INVOICE_ORDERS'
export const UPDATE_INVOICE_ORDERS_TOTAL = 'UPDATE_INVOICE_ORDERS_TOTAL'
export const UPDATE_ORDERS_TOTAL = 'UPDATE_ORDERS_TOTAL'

const mutations: MutationTree<OrderingState> = {
  [ADD_INVOICE_ORDERS] (state, invoiceId: number) {
    const invoiceOrders: InvoiceOrders = makeRelationalObject()

    Vue.set(state.invoices.orders, invoiceId, invoiceOrders)
  },

  [ADD_ORDER] (state, order: Order) {
    state.orders.elements.push(order)
  },

  [APPLY_ORDER_FILTERS] (state, filters: OrderFilters) {
    const old = state.orders.query

    state.orders.query = {
      index: old.index,
      length: old.length,
      invoiceId: old.invoiceId,
      shopId: old.shopId,
      orderBy: old.orderBy,
      ...filters
    }
  },

  [CLEAR_INVOICES_ORDERS] (state) {
    state.invoices.orders = {}
  },

  [INCREMENT_ORDERS_QUERY_INDEX] (state, offset: number) {
    state.orders.query.index = (state.orders.query.index ?? 0) + offset
  },

  [LOADED_ALL_INVOICE_ORDERS] (state, invoiceId: number) {
    const invoiceOrders = state.invoices.orders[invoiceId]

    if (invoiceOrders === undefined) {
      throw new Error(`Orders relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrders.didLoadAll = true
  },

  [LOADED_ALL_ORDERS] (state) {
    state.orders.didLoadAll = true
  },

  [RESET_LOADED_ALL_INVOICE_ORDERS] (state, invoiceId: number) {
    const invoiceOrders = state.invoices.orders[invoiceId]

    if (invoiceOrders === undefined) {
      throw new Error(`Orders relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrders.didLoadAll = false
  },

  [RESET_LOADED_ALL_ORDERS] (state) {
    state.orders.didLoadAll = false
  },

  [RESET_ORDERS_QUERY_INDEX] (state) {
    state.orders.query.index = 0
  },

  [SET_ORDERS_DEFAULT_FILTERS_FLAG] (state, isDefaultFilters: boolean) {
    state.orders.isDefaultFilters = isDefaultFilters
  },

  [UPDATE_INVOICE_ORDERS] (
    state,
    { invoiceId, orders }: { invoiceId: number; orders: number[] }
  ) {
    const invoiceOrders = state.invoices.orders[invoiceId]

    if (invoiceOrders === undefined) {
      throw new Error(`Orders relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrders.ids = new Set(orders)
  },

  [UPDATE_INVOICE_ORDERS_TOTAL] (
    state,
    { invoiceId, total }: { invoiceId: number; total: number }
  ) {
    const invoiceOrders = state.invoices.orders[invoiceId]

    if (invoiceOrders === undefined) {
      throw new Error(`Orders relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrders.total = total
  },

  [UPDATE_ORDERS] (state, orders: Order[]) {
    state.orders.elements = orders
  },

  [UPDATE_ORDERS_TOTAL] (state, total: number) {
    state.orders.total = total
  }
}

export default mutations
